import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ToggleValues from '@shared/helpers/feature-toggles';
import { GatekeeperService } from '@shared/services';
import { FeatureToggle, IFeatureToggle } from '@store/reducers/feature/feature.reducer';
import { catchError, switchMap } from 'rxjs';
import { of } from 'rxjs';

import {
  EnableFeatureToggles,
  FeatureTogglesLoaded,
  GetAndSetAllFeatureToggles,
  LogError,
} from '../../actions';

@Injectable()
export class FeatureEffects {
  constructor(
    private actions$: Actions,
    private gateKeeperService: GatekeeperService,
  ) {}

  setToggles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetAndSetAllFeatureToggles),
      switchMap(() => {
        const featureToggles = Object.keys(FeatureToggle)
          .map((key) => ToggleValues[key])
          .filter((x) => !!x);
        const invertedToggleValues = Object.entries(ToggleValues).reduce((acc, [key, value]) => {
          acc[value] = key;
          return acc;
        }, {});
        return this.gateKeeperService.getGatekeeperMulti(featureToggles).pipe(
          switchMap((toggles: IFeatureToggle[]) => [
            EnableFeatureToggles({
              payload: toggles
                .filter((x) => x.enabled)
                .map((x) => FeatureToggle[invertedToggleValues[x.featureId]]),
            }),
            FeatureTogglesLoaded(),
          ]),
          catchError((error) => {
            // Log error but still allow app to continue with default feature toggles
            return of(
              LogError({
                payload: {
                  message: 'Gatekeeper service failed, proceeding with default feature toggles',
                  error,
                  eventId: 'gatekeeper-failure',
                },
              }),
              FeatureTogglesLoaded(),
            );
          }),
        );
      }),
    ),
  );
}
